import axios from 'axios';
import Promise from 'core-js/es/promise';
import { urls } from '@/common/constants/const-url';
import { NBRBAuth2 } from '@itbelcom/nbrb-auth2';

class NbrbAuth2Instance {
    private authorizationInstance;
    private config;

    public getInstance() {
        if (this.authorizationInstance) {
            return Promise.resolve(this.authorizationInstance);
        }
        return this.Initialize();
    }

    public getToken() {
        return getInstance()
            .then(instance => {
                return instance.getAuthToken();
            });
    }

    private Initialize() {
        let axiosInstance = axios.create();
        axiosInstance.interceptors.response.use(response => axiosOptionsInit(response),
            function (error) {
                let out = {
                    $adapter: 'axios',
                    config: error.config,
                    data: null,
                    status: -1,
                    statusText: '',
                    xhrStatus: 'complete'
                };
                if (error.response) {
                    out.data = error.response.data;
                    out.status = error.response.status;
                    out.statusText = error.response.statusText;
                    out.xhrStatus = 'complete';
                }
                return Promise.reject(out);
            });
        return axios.get(urls.urlApplicationConfig)
            .then(response => {
                this.config = response.data.viewModel.NBRBAuthInit;
                this.config.ajax = axiosInstance;
                if (!this.authorizationInstance) {
                    this.authorizationInstance = new NBRBAuth2(this.config);
                }
                return Promise.resolve(this.authorizationInstance);
            })
            .catch(error => {
                console.error(error);
                return Promise.reject(error);
            });

    }

}

function axiosOptionsInit(response) {
    let out = {
        $adapter: 'axios',
        config: response.config,
        data: response.data,
        headers: response.headers,
        status: response.status,
        statusText: response.statusText,
        xhrStatus: 'complete'
    };
    return out;
}

let nbrbAuth2Instance = new NbrbAuth2Instance;

export function getInstance() {
    return nbrbAuth2Instance.getInstance();
}

export function getToken() {
    return nbrbAuth2Instance.getToken();
}



// WEBPACK FOOTER //
// ./common/module/PortalAuthInstance.ts